import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import { colorToHsl, printCss } from 'lib/color';

// Emits the CSS custom-property lines for every color in `colors` for a given
// channel suffix ('' = full hsl(), 'h'/'s'/'l' = the individual HSL channels).
const buildColorVars = (colors, suffix, convert) =>
    Object.keys(colors)
        .map((key) => printCss(suffix, convert)(key, colors[key]))
        .join('');

const ApplyBranding = ({ colors, modalBorderRadius, fontFamily, buttonBorderRadius }) => {
    if (!colors) {
        return null;
    }

    return (
        <Helmet>
            <style>
                {`:root {
                    ${buildColorVars(colors, '', (color) => {
                        const [h, s, l] = colorToHsl(color);
                        return `hsl(${h}, ${s}%, ${l}%)`;
                    })}
                    ${buildColorVars(colors, 'h', (color) => colorToHsl(color)[0])}
                    ${buildColorVars(colors, 's', (color) => `${colorToHsl(color)[1]}%`)}
                    ${buildColorVars(colors, 'l', (color) => `${colorToHsl(color)[2]}%`)}
                    --modalBorderRadius: ${modalBorderRadius};
                    --fontFamily: ${fontFamily};
                    --buttonBorderRadius: ${buttonBorderRadius};
                }`}
            </style>
        </Helmet>
    );
};

ApplyBranding.propTypes = {
    colors: PropTypes.object,
    modalBorderRadius: PropTypes.string,
    fontFamily: PropTypes.string,
    buttonBorderRadius: PropTypes.string,
};

export default ApplyBranding;
